const FOOD_SUPPORT_DEFAULT = '573192635819'
const FOOD_SUPPORT_TEXT = 'Hola, necesito soporte para activar mi Food Plan.'

function digitsFrom(raw: unknown) {
  const d = String(raw || '').replace(/\D/g, '')
  return d.length >= 10 ? d : ''
}

/** WhatsApp de gym/coach (branding shell) o el de plataforma Food. */
export function foodSupportWaUrl(user: any, text = FOOD_SUPPORT_TEXT) {
  const branding = user?.shellBranding || user?.branding || {}
  const fromBrand = digitsFrom(
    branding.support_whatsapp
    || branding.supportWhatsapp
    || branding.whatsapp
    || branding.gym_support_whatsapp,
  )
  const fromUser = digitsFrom(user?.support_whatsapp || user?.supportWhatsapp)
  const phone = fromBrand || fromUser || FOOD_SUPPORT_DEFAULT
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`
}
